import React, { Component } from "react";
import VehicleReportTableHeader from "./VehicleReportTableHeader";
import VehicleReportTablePivot from "./VehicleReportTablePivot";
import VehicleReportTableDaysContent from "./VehicleReportTableDaysContent";
import { Scrollbars } from "react-custom-scrollbars-2";
import styles from "./vehicleReportTable.module.scss";

class VehicleReportTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openDashboards: props.dataState.openDashboards,
      selectDate: props.dataState.selectDate,
    };
  }

  componentDidMount() {
    const { scrollbar } = this.refs;

    scrollbar.scrollTop(this.props.dataState.scroll);
  }

  componentWillUnmount() {
    const { scrollbar } = this.refs;
    const { openDashboards, selectDate } = this.state;

    this.props.onSetDataState({
      scroll: scrollbar.getScrollTop(),
      openDashboards: openDashboards,
      selectDate: selectDate,
    });
  }

  onOpenDashboard(day) {
    const { openDashboards } = this.state;

    this.setState({ openDashboards: openDashboards.concat(day) });
  }

  onCloseDashboard(day) {
    const { openDashboards } = this.state;

    this.setState({
      openDashboards: openDashboards.filter((item) => {
        return item !== day;
      }),
    });
  }

  handlerRowClick(selectDate) {
    this.setState({ selectDate });
  }

  render() {
    const { tableData, height = 300, handleClickRow } = this.props;
    const { openDashboards, selectDate } = this.state;

    return (
      <div className={styles.reportTableContainer}>
        <VehicleReportTableHeader header={tableData.header} />
        <Scrollbars style={{ height: height + "px" }} autoHide={true} ref="scrollbar">
          <VehicleReportTableDaysContent
            selectDate={selectDate}
            handleClickRow={handleClickRow}
            handlerRowClick={this.handlerRowClick.bind(this)}
            days={tableData.days}
            openDashboards={openDashboards}
            onOpenDashboard={this.onOpenDashboard.bind(this)}
            onCloseDashboard={this.onCloseDashboard.bind(this)}
          />
          <VehicleReportTablePivot pivot={tableData.pivot} />
        </Scrollbars>
      </div>
    );
  }
}

export default VehicleReportTable;
